import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { Heading } from 'components';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

export const PopupText = ({ children, isTitle }) => (
  isTitle ? <Heading level={2}>{children}</Heading>
    : (
      <div className={cx('component')}>
        <Text size="size5-r-s" tagType="p">{children}</Text>
      </div>
    )
);

PopupText.propTypes = {
  children: PropTypes.string,
  isTitle: PropTypes.bool,
};
